<template>
    <div id="app">
        <Header />
        <!-- <Banner /> -->
        <Section />
        <Section1 />
        <Footer />
    </div>
</template>



<script>
import Header from '@/components/Header.vue'
// import Banner from '@/components/Banner.vue'
import Section1 from '@/components/Section1.vue'
import Section from '@/components/Section.vue'
import Footer from '@/components/Footer.vue'


export default {
    name: 'App',
    components: {
        Header,
        Section,
        Section1,
        Footer,
    },
}

</script>


<style>
@import url("https://fonts.googleapis.com/css?family=Noto+Sans+TC:wght@100;300&display=swap");
@import url('https://fonts.googleapis.com/css2?family=Noto+Serif+TC:wght@500;600;700&display=swap');


video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;

}


section {
    display: block;
}

a {
    color: black;
    text-decoration: none;
    display: block;
    transition: 0.3s;

}



i {
    cursor: pointer;
}

body {
    line-height: 1.4;
}

ol,
ul {
    list-style: none;
}

blockquote,
q {
    quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
    content: '';
    content: none;
}

table {
    border-collapse: collapse;
    border-spacing: 0;
}

h3,
h4,
p {
    font-size: 16px;
    line-height: 1.56;
}

#app {

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
}
</style>

<style>
* {
    scroll-behavior: smooth;
}

p {
    font-size: 1.2rem;
}

h2 {
    text-align: center;
    font-size: 1.2rem;
}

h3 {
    overflow: hidden;
    font-size: 1rem;
    line-height: 150%;
}


@media screen and (min-width: 768px) {
    h2 {
        text-align: center;
        font-size: 1.4rem;
    }

    h3 {
        overflow: hidden;
        font-size: 1.1rem;
    }
}

img,
picture {
    width: 100%;
    height: auto;
}

.btn_more {
    margin-top: 3rem;
}

.fa-solid {
    color: #525b7c;
}

.layout {
    margin: auto;
}

.layout_grid {
    max-width: 1200px;
    margin: auto;
    display: grid;
    /* padding: 4.1rem 1rem; */
}

#section_news,
#section1,
#section2,
#section3 {
    min-height: 500px;
}

@media screen and (max-width: 768px) {

    #section_news,
    #section1,
    #section2,
    #section3 {
        min-height: 500px;
    }
}

.layout_inner .layout_photo p {
    text-align: left;
    font-size: 1rem;
    padding: 1rem 3rem 2rem !important;
}

/* 4x3 縱橫比 */
.iframe-container {
    overflow: hidden;
    padding-top: 56.25%;
    position: relative;
    margin-top: 3rem;
    z-index: 1;
    width: 100%;
    min-height: 100px;
}

.iframe-container iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}

.iframe-container-4x3 {
    padding-top: 75%;
}

.title {
    font-size: 1.2rem;
}
</style>
